export const DataDendaBefore22Aug2023 = {
  col: 4,
  heading: ["Jumlah Hari Keterlambatan", "Denda", "Perhitungan Denda", "Total"],
  content: [
    {
      items: ["5 Hari Keterlambatan", "Rp50.000", "Rp50.000", "Rp50.000"]
    },
    {
      items: [
        "30 Hari Keterlambatan",
        "+Rp75.000",
        "Rp50.000 + Rp75.000",
        "Rp125.000"
      ]
    },
    {
      items: [
        "60 Hari Keterlambatan",
        "+Rp150.000",
        "Rp50.000 + Rp75.000 + Rp150.000",
        "Rp275.000"
      ]
    },
    {
      items: [
        "90 Hari Keterlambatan",
        "Rp175.000",
        "Rp50.000 + Rp75.000 + Rp150.000 + Rp175.000",
        "Rp450.000"
      ]
    }
  ]
};

export const DataDendaAfter22Aug2023 = {
  col: 2,
  heading: [
    "Jumlah Hari Keterlambatan",
    "Persentase Denda Keterlambatan Pembayaran Cicilan"
  ],
  content: [
    {
      items: ["1 Hari Keterlambatan", "8%"]
    },
    {
      items: ["15 Hari Keterlambatan", "8%"]
    },
    {
      items: ["35 Hari Keterlambatan", "8%"]
    },
    {
      items: ["45 Hari Keterlambatan", "8%"]
    },
    {
      items: ["65 Hari Keterlambatan", "8%"]
    },
    {
      items: ["95 Hari Keterlambatan", "8%"]
    },
    {
      items: ["125 Hari Keterlambatan", "8%"]
    },
    {
      items: ["155 Hari Keterlambatan", "8%"]
    }
  ]
};

export const DataDendaSimulationExample = {
  col: 3,
  heading: [
    "Jumlah Hari Keterlambatan",
    "Denda <br /> (8% dari total cicilan tertunggak)",
    "Jumlah yang Harus Dibayar<br/>(Total cicilan tertunggak + total denda)"
  ],
  content: [
    {
      items: ["1 Hari Keterlambatan", "Rp500.000 X 8% = Rp40.000", "Rp540.000"]
    },
    {
      items: ["15 Hari Keterlambatan", "Rp500.000 X 8% = Rp40.000", "Rp580.000"]
    },
    {
      items: [
        "35 Hari Keterlambatan",
        "Rp1.000.000 X 8% = Rp80.000",
        "Rp1.160.000"
      ]
    },
    {
      items: [
        "45 Hari Keterlambatan",
        "Rp1.000.000 X 8% = Rp80.000",
        "Rp1.240.000"
      ]
    },
    {
      items: [
        "65 Hari Keterlambatan",
        "Rp1.500.000 X 8% = Rp120.000",
        "Rp1.860.000"
      ]
    },
    {
      items: [
        "95 Hari Keterlambatan",
        "Rp2.000.000 X 8% = Rp160.000",
        "Rp2.520.000"
      ]
    },
    {
      items: [
        "125 Hari Keterlambatan",
        "Rp2.500.000 X 8% = Rp200.000",
        "Rp3.220.000"
      ]
    },
    {
      items: [
        "155 Hari Keterlambatan",
        "Rp3.000.000 X 8% = Rp240.000",
        "Rp3.960.000"
      ]
    }
  ]
};

export const DataDendaFlexicashBefore22Aug2023 = {
  col: 4,
  heading: ["Jumlah Hari Keterlambatan", "Denda", "Perhitungan Denda", "Total"],
  content: [
    {
      items: ["5 Hari Keterlambatan", "Rp75.000", "Rp75.000", "Rp75.000"]
    },
    {
      items: [
        "30 Hari Keterlambatan",
        "Rp150.000",
        "Rp75.000 + Rp150.000",
        "Rp225.000"
      ]
    },
    {
      items: [
        "60 Hari Keterlambatan",
        "Rp175.000",
        "Rp75.000 + Rp150.000 + Rp175.000",
        "Rp400.000"
      ]
    },
    {
      items: [
        "90 Hari Keterlambatan",
        "Rp200.000",
        "Rp75.000 + Rp150.000 + Rp175.000 + Rp200.000",
        "Rp600.000"
      ]
    },
    {
      items: [
        "120 Hari Keterlambatan",
        "Rp225.000",
        "Rp75.000 + Rp150.000 + Rp175.000 + Rp200.000 + Rp225.000",
        "Rp825.000"
      ]
    },
    {
      items: [
        "150 Hari Keterlambatan",
        "Rp250.000",
        "Rp75.000 + Rp150.000 + Rp175.000 + Rp200.000 + Rp225.000 + Rp250.000",
        "Rp1.075.000"
      ]
    }
  ]
};

export const DataDendaC = {
  col: 4,
  heading: ["Jumlah Hari Keterlambatan", "Denda", "Perhitungan Denda", "Total"],
  content: [
    {
      items: ["5 Hari Keterlambatan", "Rp10.000", "Rp10.000", "Rp10.000"]
    },
    {
      items: [
        "30 Hari Keterlambatan",
        "Rp15.000",
        "Rp10.000 + Rp15.000",
        "Rp25.000"
      ]
    },
    {
      items: [
        "60 Hari Keterlambatan",
        "Rp30.000",
        "Rp10.000 + Rp15.000 + Rp30.000",
        "Rp55.000"
      ]
    },
    {
      items: [
        "90 Hari Keterlambatan",
        "Rp35.000",
        "Rp10.000 + Rp15.000 + Rp30.000 + Rp35.000",
        "Rp90.000"
      ]
    }
  ]
};

export const DataDendaD = {
  col: 4,
  heading: ["Jumlah Hari Keterlambatan", "Denda", "Perhitungan Denda", "Total"],
  content: [
    {
      items: ["5 Hari Keterlambatan", "Rp50.000", "Rp50.000", "Rp50.000"]
    },
    {
      items: [
        "30 Hari Keterlambatan",
        "Rp75.000",
        "Rp50.000 + Rp75.000",
        "Rp125.000"
      ]
    },
    {
      items: [
        "60 Hari Keterlambatan",
        "Rp150.000",
        "Rp50.000 + Rp75.000 + Rp150.000",
        "Rp275.000"
      ]
    },
    {
      items: [
        "90 Hari Keterlambatan",
        "Rp175.000",
        "Rp50.000 + Rp75.000 + Rp150.000 + Rp175.000",
        "Rp450.000"
      ]
    }
  ]
};

export const DataDendaE = {
  col: 2,
  heading: ["Jumlah Hari Keterlambatan", "Perhitungan Denda"],
  content: [
    {
      items: ["5 Hari Keterlambatan", "+1% Atau Maksimal Rp100.000"]
    },
    {
      items: ["30 Hari Keterlambatan", "+1% Atau Maksimal Rp100.000"]
    },
    {
      items: ["60 Hari Keterlambatan", "+1% Atau Maksimal Rp100.000"]
    }
  ]
};
